import React, { FC, MouseEventHandler } from 'react';
import { Icon } from '../../Icon/Icon';
require("./Search-ActionButton.css");
var styles = {
  "Root": "Search-ActionButton-module-Root_KXw"
};
const iconEnhancersMap = {
  close: 'close',
  microphone: 'microphone',
  camera: 'camera'
};
export const SearchActionButton = ({
  icon,
  onClick,
  isVisible
}) => {
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: styles.Root
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    size: "m"
  }));
};